import React from 'react';
import { connect } from 'react-redux';
import { createActions } from '../../../../store';
import SliderListItem from '../../../../../../list-items/SliderListItem';
import { previewHistoryBatch } from '../../../../store/extensions';

const VisualizerSpinSpeedListItem = ({ speed, updateVisualizerSettings }) => {
    const onSpeedChange = (value) => {
        previewHistoryBatch.start();
        updateVisualizerSettings({
            spinSettings: { speed: value }
        });
    };

    return (  
        <SliderListItem
            title='Speed'
            value={speed}
            displayMultiplier={1}
            min={-100}
            max={100}
            step={1}
            onValueChange={onSpeedChange}
        /> 
    );
};

const mapStateToProps = (state) => {
    const { speed } = state.createPreview.present.videoSettings.visualizer.spinSettings;
    return { speed };
}

const mapDispatchToProps = (dispatch) => {
    const updateVisualizerSettings = (properties) => dispatch(createActions.updateVisualizerSettings(properties));
    return { updateVisualizerSettings }
}

export default connect(mapStateToProps, mapDispatchToProps)(VisualizerSpinSpeedListItem);